module.exports = __webpack_public_path__ + "static/media/Red-Cross.4b2e42ca.jpg";